export const apiUrls = {
  //admin
  adminLogin: "admin/login",
  adminGetDrivers: 'admin/getdrivers',
  adminGetUsers: 'admin/getusers',
  adminGetDashboard: 'admin/dashBoard',
  adminGetAllFleet: 'admin/get-allfleet',
  adminFleetStatusUpdate: 'admin/fleet-status-Update',
  adminDeleteFleet: 'admin/delete-fleet',
  adminDeleteDrivers: 'admin/deletedrivers',
  adminDeleteUsers: 'admin/deleteusers',
  adminAddUsers: 'admin/add-user',
  adminProfile: 'admin/profile',
  adminGetVehicleType: 'admin/get-vehicle',
  adminUpdateStatusVehicleType: 'admin/updatestatus-vehicle',
  adminDeleteVehicleType: 'admin/delete-vehicle',
  adminAddVehicleType: 'admin/add-vehicle',
  adminUpdateVehicle: 'admin/update-vehicle',
  adminGetVehicleBrand: 'admin/get-vehiclebrand',
  adminAddVehicleBrand: 'admin/add-vehiclebrand',
  adminUpdateVehicleBrand: 'admin/update-vehiclebrand',
  adminDeleteVehicleBrand: 'admin/delete-vehiclebrand',
  adminUpdateStatusVehicleBrand: 'admin/updatestatus-vehiclebrand',
  adminAddUser: 'admin/add-user',
  adminUpdateUser: 'admin/update-user',
  adminUpdateUserStatus: 'admin/update-user-status',
  adminCreateDriver: 'admin/create-driver',
  adminUpdateDriver: 'admin/update-driver',
  adminGetAllFleets: 'admin/get-allfleets',
  adminDriverStatusUpdate: 'admin/update-driver-status',
  adminCreateFleet: 'admin/create-fleet',
  adminUpdateFleet: 'admin/update-fleet',
  adminGetVehicleList: 'admin/get-vehicles',
  adminBrandVehicle: 'admin/get-vehicle-brands',
  adminCargoTypes: 'admin/cargo-types',
  adminAddCargoType: 'admin/cargo-types/add',
  adminUpdateCargoType: 'admin/cargo-types/update',
  adminDeleteCargoType: 'admin/cargo-types/delete',
  adminUpdateStatusCargoType: 'admin/cargo-types/status',
  adminGetShipments: 'admin/shipments',
  adminApproveShipment: 'admin/shipments',
  adminAssignShipment: 'admin/shipments',
  adminReassignShipment: 'admin/shipments',
  adminPendingAssignments: 'admin/shipments/pending-assignment',
  adminGetShippers: 'admin/shippers',
  adminShipmentsAllShippers: 'admin/shipments/all-shippers',
  businessAdd: 'admin/business/add',
  businessUpdate: 'admin/business/update',
  businessDelete: 'admin/business/delete',
  businessStatus: 'admin/business/status',
  businessGet: 'admin/business/get',
  licenseGet: 'admin/license/get',
  licenseAdd: 'admin/license/add',
  licenseUpdate: 'admin/license/update',
  licenseDelete: 'admin/license/delete',
  licenseStatus: 'admin/license/status',
  adminLicenseGetAll: 'admin/license/getall',
  adminBusinessGetAll: 'admin/business/getall',

  //user
  signup: 'signup',
  signin: 'signin',
  getProfile: 'get-profile',
  editProfile: 'edit-profile',
  singleImage: 'upload/single',
  multiImage: 'upload/multiImage',
  createDriver: 'create-driver',
  getAllDrivers: 'get-alldrivers',
  updateDriver: 'update-driver',
  createFleet: 'create-fleet',
  getAllFleet: 'get-allfleet',
  updateFleet: 'update-fleet',
  sendOtp: 'send-otp',
  verifyOtp: 'verify-otp',
  verifySignup: 'verify-signup',
  deleteFleet: 'delete-fleet',
  deleteDriver: 'delete-driver',
  getAllfleets: 'get-allfleets',
  fleetStatusUpdate: 'update-fleet-status',
  driverStatusUpdate: 'update-driver-status',
  getVehicles: 'get-vehicles',
  getVehicleBrands: 'get-vehicle-brands',
  forgetPassword: 'forget-password',
  changePassword: 'change-password',
  getCompanyDetail: 'get-company-detail',
  browseLoads: 'loads/browse',
  loadsStatus: 'loads/status',
  submitBid: 'loads/submit-bid',
  searchLoads: 'loads/search',
  assignDriver: 'bids/assign-driver',
  shipmentsCreate: 'shipments/create',
  shipmentsCargoTypes: 'shipments/cargo-types',
  shipmentsSubmit: 'shipments',
  shipmentsMarketplaceAll: 'shipments/marketplace/all',
  createBid: 'shipments/bids/create',
  shipmentsGetMyShipment: 'shipments/getmyshipment',
  shipmentsDashboard: 'shipments/dashboard',
  shipmentsBidsMyBids: 'shipments/bids/my-bids',
  assignDriver: 'bids/assign-driver',
  uploadPod: 'bids/upload-pod',
  markDelivered: 'bids/mark-delivered',
  availableDrivers: 'drivers/available',
  availableVehicles: 'vehicles/available',
  businessGetAll: 'business/getall',
  licenseGetAll: 'license/getall',
  walletGet: 'wallet/get',
  stripeRedirect: 'stripe/redirect',
  stripeOnboardingRefresh: 'stripe/onboarding/refresh',
  stripeOnboardingComplete: 'stripe/onboarding/complete',
  onboardingRequirementsGet: 'stripe/onboarding-requirements',
  onboardingRequirementsSubmit: 'stripe/onboarding-requirements',
  stripeSupportedCountries: 'stripe/supported-countries',
  bankAccountCurrency: 'stripe/bank-account-currency',
  proofOfLivenessSession: 'stripe/proof-of-liveness-session',
  bankAccountAdd: 'funds/bank-account',
  fundsAdd: 'funds/add',
  fundsWidthdraw: 'funds/widthdraw',
  createsetupintent: 'funds/createsetupintent',
  saveMethod: 'card/save',
  walletHistory: 'wallet/history',
  escrowTransfer: 'escrow/transfer',
  paymentCreateIntent: 'payment/create-intent',
  paymentConfirm: 'payment/confirm',
  adminGetPaymentDetails: 'admin/payments',
  shipmentsMyShipments: 'shipments/my-shipments',
  shipmentSearch: 'shipment/search',
  driverGet: 'driver/get',
  shipmentAssign: 'shipment/assign',
  notificationGet: 'notification/get',
  notificationIsRead: 'notification/isRead',
  fcmToken: 'notification/token',
  fcmTokenRemove: 'notification/token/remove',
  adminGetPayments: 'admin/payments',
  adminPaymentsSummary: 'admin/payments/summary',
  adminUpdatePaymentStatus: 'admin/payments',
  shipmentsAvailableLoads: 'shipments/available-loads',
  walletEarningsTrend: 'wallet/earnings-trend',
  invoiceGenerate: 'invoice/generate',
  invoiceMyInvoices: 'invoice/my-invoices',
  invoiceGetById: 'invoice',
  invoiceDownload: 'invoice',
  invoiceUpdateStatus: 'invoice',
  documentUpload: 'document/upload',
  documentMyDocuments: 'document/my-documents',
  documentGetByIdAndDelete: 'document',
};
